module.exports = __webpack_public_path__ + "static/media/inflator-badge.6597a165.svg";